<!--  -->
<template>
  <div class="goods-panel" @click="handleTarget">
    <el-image class="img-url" :style="{ height: height, width: width }" :src="coverImage"></el-image>
    <span class="coming-soon-badge" v-if="saleStartSwitch==1&&saleAllow==0">即将开售 Available soon</span>
    <div class="goods-desc-content">
      <template v-if="spuName">
        <div class="goods-name sl-ellipsis">{{ spuName }}</div>
        <div class="goods-name-en sl-ellipsis">{{ spuNameEn }}</div>
      </template>
      <slot v-else></slot>
    </div>
    <div v-if="price" class="goods-price-content">
      <span class="price">￥{{ price }}</span>
      <span class="oprice" v-if="oprice&&opriceEmpty">￥{{ oprice }}</span>
    </div>
    <slot v-else name="price"></slot>
  </div>
</template>

<script>
export default {
  components: {},
  props: {
    id: {
      type: [String, Number],
      default: "",
    },
    coverImage: {
      type: String,
      default: "",
    },
    titleEn: {
      type: String,
      default: "",
    },
    price: {
      type: String,
      default: "",
    },
    oprice: {
      type: String,
      default: "",
    },
    spuName: {
      type: String,
      default: "",
    },
    spuNameEn: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "380px",
    },
    height: {
      type: String,
      default: "380px",
    },
    saleStartSwitch:{
      type:Number,
      default:0
    },
    saleAllow:{
      type:Number,
      default:0
    }
  },
  data() {
    return {};
  },
  computed: {
    opriceEmpty(){

      return this.oprice!='0.00'
    }
  },
  watch: {},
  mounted() {},
  methods: {
    handleTarget() {
      this.$emit("handleTarget", this.id);
    },
  },
};
</script>
<style lang="scss" scoped>
.goods-panel {
  background: #ffffff;
  box-shadow: 0px 6px 40px 0px rgba(204, 204, 204, 0.3);
  padding-bottom: 40px;
  cursor: pointer;
  position: relative;
  .img-url {
    width: 100%;
  }
  .goods-desc-content {
    margin-top: 30px;
    line-height: 1.5;
    > div {
      font-size: 18px;
      font-weight: 400;
      color: #333333;
      padding: 0 30px;
    }
  }
  .goods-price-content {
    display: flex;
    align-items: center;
    margin-top: 56px;
    padding: 0 33px;
    .price {
      font-size: 18px;
      font-weight: bold;
      color: #333333;
    }
    .oprice {
      font-size: 18px;
      text-decoration: line-through;
      color: #333333;
      margin-left: 28px;
    }
  }
}
.coming-soon-badge{
  color: #ffffff;
  font-size: 14px;
  position: absolute;
  box-sizing: border-box;
  padding: 10px 15px;
  left: 20px;
  top: 20px;
  z-index: 1;
  background: rgba(197,129,29,0.58);
  border-radius: 3px;
}
</style>
